import { Component, OnInit } from '@angular/core';
import { BaseDatasourceComponent } from '../base-datasource/base-datasource.component';
import { Shared, UserService } from '@rubii/frontend-common';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-ias',
  templateUrl: './ias.component.html',
  styleUrls: ['./ias.component.scss']
})
export class IasComponent extends BaseDatasourceComponent implements OnInit {

  iasEmail = '';

  constructor(private user: UserService, private snack: MatSnackBar) {
    super();
  }

  ngOnInit() {
    this.iasEmail = 'report+ias+' + this.user.user.tenant.token + '+' + this.user.user.id + '@rubii.io';
  }

  copyMessageToClipboard(content: string): void {
    const textarea = document.createElement('textarea');
    textarea.value = content;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    this.openSnackBar(this.snack,'Email address copied', 'Close');
    console.log('Message copied to clipboard');
  }

}
